import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  Environment
} from '@vodacom/web-env';

import {
  Base,
  Image,
  Text,
  VContainerVH,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

const TechnicalErrorUI = (props) => {

  return (

    <VFillContainerVH
      padding={'0 16px 16px 16px'}
      textAlign={'center'}>

      <Base
        margin={'15% auto'}>

        <Image
          src={Icons.ConnectU}
          height={'40px'}
          width={'164px'}/>

      </Base>

      <Base
        margin={'0 27px 16px 28px'}>

        <Text
          fontSize={'20px'}
          textAlign={'center'}
          fontWeight={'500'}
          color={CustomColors.Grey11}>

          {props.title}
        </Text>
      </Base>

      <Text
        fontSize={'16px'}
        textAlign={'center'}
        color={CustomColors.Grey9}>

        {props.message}
      </Text>

      <VContainerVH
        padding={'0 12px'}
        margin={'auto 0 16px'}
        width={'100%'}
        boxSizing={'border-box'}>

        { props.showRefreshButton &&

          <PrimaryButton
            text={props.topButtonText}
            onClick={() => window?.location?.reload()}
            margin={'0 0 16px'}/>
        }

        <SecondaryButton
          text={props.bottomButtonText}
          onClick={() => { props.bottomButtonClick ? props.bottomButtonClick() : window.location.href = '/home';}}/>

      </VContainerVH>

    </VFillContainerVH>
  );
};

TechnicalErrorUI.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  topButtonText: PropTypes.string,
  bottomButtonText: PropTypes.string,
  bottomButtonClick: PropTypes.func,
  showRefreshButton:PropTypes.bool
};

TechnicalErrorUI.defaultProps = Environment.current.technicalErrorDetails;

// TODO: Add analytics
TechnicalErrorUI.pageName = 'cbu: connectu: technical error page';
TechnicalErrorUI.tagViewData = {
  page_section: 'error pages',
  page_event: 'We are currently experiencing technical difficulties',
  error_message: 'page not found'
};

export const TechnicalError = withScreenViewTagging(TechnicalErrorUI);
